import { connect } from 'react-redux';

import { fetchLicense } from '../actions/license';

import { LicenseTable } from '../components/license-list';

const mapState = state => ({
  accessToken: state.user.accessToken,
  userToken: state.user.profile.token,
  isAdmin: state.user.profile.isAdmin,
  isFetching: state.license.isFetching,
  data: state.license.data,
  total: state.license.total,
  page: state.license.page,
  pageSize: state.license.pageSize,
  sort: state.license.sort,
  filter: state.license.filter
});

const mapDispatch = {
  fetchLicense
};

export default connect(
  mapState,
  mapDispatch
)(LicenseTable);
